import { default as byteSize } from 'byte-size'

import { ProgressBar } from '@corabank/arco'

import { FileProps } from './interface'
import * as Styled from './styles'

const File = ({
  file,
  uploaded,
  uploadProgress,
  className,
}: FileProps): JSX.Element | null => {
  if (!file) return null
  const { value, unit } = byteSize(file.size ?? 0)

  return (
    <Styled.Infos className={className}>
      <Styled.InfosName title={file.name} uploaded={uploaded}>
        {file.name}
      </Styled.InfosName>
      {uploaded ? (
        <Styled.InfosSize>{`${value} ${unit}`}</Styled.InfosSize>
      ) : (
        <ProgressBar progress={uploadProgress} />
      )}
    </Styled.Infos>
  )
}

export { File }
